import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import Header from "../Header/Header";
// import Menu from "./Menu";
import Footer from "../Footer/Footer";
// import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { MdStar } from "react-icons/md";
// import { IoIosArrowBack } from "react-icons/io";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import { Helmet } from "react-helmet";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
import { IoHomeOutline } from "react-icons/io5";
// import { ca } from "date-fns/locale";
const CategoryPage = () => {
  const { categoryName, subCategoryName } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
   const location = useLocation();
   const data = location.state || {};
   const categoryId = data.categoryId || null;
  const displayName = (categoryName)?.replace(/-/g, " ") || "";
  const selectedCategory = categoryName?.charAt(0).toUpperCase() + categoryName?.slice(1) || "";
  const slugify = (text) => text.toLowerCase().replace(/\s+/g, "-");
  const [sortBy, setSortBy] = useState("");
  const handleRedirect = (phone, id, title) => {
    const link = `https://rentel.in?productId=${id}`;
    const msg = `Hello, I'm interested in your product: ${title}\nCheck it here: ${link}`;
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );
  };
  useEffect(() => {
    let url = "";
    if (subCategoryName) {
      url = `https://network.rentel.in/products/get-user-products?subCategory=${encodeURIComponent(
        subCategoryName
      )}`;
    } else if (categoryId) {
      url = `https://network.rentel.in/products/get-user-products?categoryId=${encodeURIComponent(
        categoryId
      )}`;
    }

    if (!url) return;

    setLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setProducts(data?.data || data?.products || []);
        setLoading(false);
      })
      .catch(() => {
        setProducts([]);
        setLoading(false);
      });
  }, [categoryName, subCategoryName]);

  const calculateDiscountedPrice = (price, discount) =>
    !discount ? price : price - (price * discount) / 100;

  /* ================= RESPONSIVE STATES ================= */
  const [isVerySmall, setIsVerySmall] = useState(window.innerWidth <= 360);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth <= 991
  );

  useEffect(() => {
    const resize = () => {
      const w = window.innerWidth;
      setIsVerySmall(w <= 360);
      setIsMobile(w <= 767);
      setIsTablet(w >= 768 && w <= 991);
    };

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const clothSubCategories = [
    {
      name: "Men",
    },
    {
      name: "Women",
    },
    {
      name: "Children",
    }
  ];

  const VehiclesSubCategories = [
    {
      name: "Car",
    },
    {
      name: "Bike",
    },
    {
      name: "Truck",
    }
  ];
  const EventsSubCategories = [
    {
      name: "Dj & Sound",
    },
    {
      name: "Wedding events",
    },
    {
      name: "Celebration events ",
    }
  ];
  const MachinerySubCategories = [
    {
      name: "Construction machinery",
    },
    {
      name: "Textiles machinery",
    },
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });
  }, [categoryName, subCategoryName]);

  const capitalizeWords = (text = "") =>
    text
      .split(" ")
      .map(word =>
        word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : ""
      )
      .join(" ");

  /* ================= SORT ================= */

  const finalProducts = useMemo(() => {
    let list = [...products];

    if (sortBy === "price_low_high") {
      list.sort(
        (a, b) =>
          calculateDiscountedPrice(a.price, a.discount) -
          calculateDiscountedPrice(b.price, b.discount)
      );
    }

    if (sortBy === "price_high_low") {
      list.sort(
        (a, b) =>
          calculateDiscountedPrice(b.price, b.discount) -
          calculateDiscountedPrice(a.price, a.discount)
      );
    }

    return list;
  }, [products, sortBy]);


  return (
    <>

      <Helmet>
        <title>{categoryName} for Rent | Rentel</title>
        <meta
          name="description"
          content={`Browse ${categoryName} available for rent on Rentel`}
        />
      </Helmet>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Header />
          {/* <Menu /> */}
          <div className="container">
            <div className="categorye">
              <div
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  alignItems: isMobile ? "center" : "flex-end",
                  gap: "12px",
                  flexWrap: isMobile ? "wrap" : "nowrap",
                  marginBottom: "20px",
                  /* 🔥 ONLY TABLET MARGIN */
                  marginTop: isTablet ? "100px" : "",
                }}
              >
                {/* LEFT SIDE: TITLE + BREADCRUMB */}
                <div
                  className="category-headerd"
                  style={{
                    flex: 1,
                    minWidth: 0, // 🔑 overflow fix
                  }}
                >
                  <h1
                    className="category-title"
                    style={{
                      fontSize: isVerySmall
                        ? "18px"
                        : isMobile
                          ? "20px"
                          : "24px",
                      lineHeight: "1.2",
                      marginBottom: "6px",
                      wordBreak: "break-word",
                    }}
                  >
                    {displayName.charAt(0).toUpperCase() + displayName.slice(1)}
                  </h1>

                  <div
                    className="category-breadcrumb"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px",
                      fontSize: isVerySmall
                        ? "12px"
                        : isMobile
                          ? "13px"
                          : "14px",
                    }}
                  >
                    <span
                      className="breadcrumb-home"
                      onClick={() => navigate("/")}
                      style={{ cursor: "pointer" }}
                    >
                      <IoHomeOutline className="hoho" /> Rentel
                    </span>
                    <span className="breadcrumb-separator">/</span>
                    <span className="breadcrumb-current">
                      {displayName.charAt(0).toUpperCase() + displayName.slice(1)}
                    </span>
                  </div>
                </div>

                {/* RIGHT SIDE: SORT */}
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  style={{
                    padding: "8px 10px",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                    height: "40px",
                    fontSize: isVerySmall
                      ? "13px"
                      : isMobile
                        ? "14px"
                        : "15px",
                    maxWidth: isVerySmall
                      ? "50%" : isMobile
                        ? "200px"
                        : "160px",
                    width: isVerySmall ? "100%" : "50%",
                    flexShrink: 0,
                  }}
                >
                  <option value="">
                    {isVerySmall ? "Sort" : "Sort by"}
                  </option>
                  <option value="price_low_high">Low → High</option>
                  <option value="price_high_low">High → Low</option>
                </select>
              </div>



              {/* ===== Cloth Sub Categories ===== */}

              {selectedCategory === "Cloth" && (
                <div className="subcategory-tabs-wrapper">
                  <ul className="subcategory-tabs">
                    {clothSubCategories.map((item) => {
                      const isActive =
                        subCategoryName === item.name.toLowerCase();

                      return (
                        <li
                          key={item.name}
                          className={`subcategory-tab ${isActive ? "active" : ""}`}
                          onClick={() =>
                            navigate(`/category/cloth/${item.name.toLowerCase()}`)
                          }
                        >
                          {item.name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}



              {/* ===== Vehicles Sub Categories ===== */}

              {selectedCategory === "Vehicles" && (
                <div className="subcategory-tabs-wrapper">
                  <ul className="subcategory-tabs">
                    {VehiclesSubCategories.map((item) => {
                      const isActive =
                        subCategoryName === item.name.toLowerCase();

                      return (
                        <li
                          key={item.name}
                          className={`subcategory-tab ${isActive ? "active" : ""}`}
                          onClick={() =>
                            navigate(`/category/vehicles/${item.name.toLowerCase()}`)
                          }
                        >
                          {item.name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              {/* ===== Events Sub Categories ===== */}

              {selectedCategory === "Events" && (
                <div className="subcategory-tabs-wrapper">
                  <ul className="subcategory-tabs">
                    {EventsSubCategories.map((item) => {
                      const isActive =
                        subCategoryName === item.name.toLowerCase();

                      return (
                        <li
                          key={item.name}
                          className={`subcategory-tab ${isActive ? "active" : ""}`}
                          onClick={() =>
                            navigate(`/category/Events/${item.name.toLowerCase()}`)
                          }
                        >
                          {item.name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              {/* ===== Machinery Sub Categories ===== */}
              {selectedCategory === "Machinery" && (
                <div className="subcategory-tabs-wrapper">
                  <ul className="subcategory-tabs">
                    {MachinerySubCategories.map((item) => {
                      const isActive =
                        subCategoryName === item.name.toLowerCase();

                      return (
                        <li
                          key={item.name}
                          className={`subcategory-tab ${isActive ? "active" : ""}`}
                          onClick={() =>
                            navigate(`/category/Machinery/${item.name.toLowerCase()}`)
                          }
                        >
                          {item.name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              {/* EMPTY / LOADING STATES OUTSIDE GRID */}
              {loading ? (
                <div className="empty-center">
                  No product available
                </div>
              ) : finalProducts.length === 0 ? (
                <div className="empty-center">
                  No results found
                </div>
              ) : (
                <div className="product-grid">
                  {finalProducts.map((item) => (
                    <div className="product-card" key={item._id}>
                      <div className="image-container">
                        <Link
                          to={`/${slugify(item.category)}/${slugify(
                            item.subCategory
                          )}/${slugify(item.title)}/${item._id}`}
                        >
                          <img
                            src={item.images?.[0] || "/fallback.jpg"}
                            alt={item.title}
                          />
                        </Link>

                        <div className="rating-badge-co">
                          <div className="rating-badgel">
                            <MdStar />
                            <h3>{item.averageRating}</h3>
                          </div>
                        </div>
                      </div>

                      <div className="all-item">
                        <p className="originale-priceo">
                          {`${item.userId?.name || ""} ${item.userId?.lastName || "Unknown Seller"
                            }`}
                        </p>

                        <div className="sprat">
                          <h3>{capitalizeWords(item.title)}</h3>
                        </div>


                        <p className="price-discounti">
                          <span className="final-priceoe">
                            ₹
                            {calculateDiscountedPrice(
                              item.price,
                              item.discount
                            ).toLocaleString("en-IN")}
                          </span>

                          {item.discount > 0 && (
                            <>
                              |
                              <span className="discounte">{item.discount}% OFF</span>
                            </>
                          )}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default CategoryPage;
